import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, isRef as _isRef, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-32c875f1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "NovoProjeto__TabMenuConteiner" }
const _hoisted_2 = {
  key: 0,
  class: "ONovoMembro__BotoesNovosMembros"
}
const _hoisted_3 = {
  key: 1,
  class: "NovoProjeto__BotoesAdicionarTiposDeAtividades"
}

import { computed, ref, reactive, watch, onBeforeMount, nextTick } from "vue"
  import { LPadrao } from "@/layouts/"
  import PButton from "primevue/button"
  import {
    MModalDeAlerta,
    IAlertaMensagem,
    OTrilhaDeNavegacao,
  } from "@/components/Gerais"
  import { MenuItem } from "primevue/menuitem"
  import {
    COR_PADRAO_PROJETO,
    CriarProjeto,
    EditarProjeto,
    ListarProjetos,
    ListarProjetosComAtividadesDoProjeto,
    MembroDoProjeto,
    ParamsProjeto,
  } from "@/repositorios/projeto/projeto.modelo"
  import { EntidadeGenerica } from "@/types/gerais"
  import { usarPermissionamento } from "@/composable/UsarPermissionamento"
  import { useRouter, useRoute } from "vue-router"
  import {
    ONovoMembro,
    ONovaAtividade,
    ODadosProjeto,
    TNovoProjeto,
  } from "@/components/Projetos"
  import useVuelidate from "@vuelidate/core"
  import ProjetoRepositorio from "@/repositorios/projeto/projeto.repositorio"
  import UsuariosRepositorio from "@/repositorios/usuarios/usuarios.repositorio"
  import AtividadesDoProjetoRepositorio from "@/repositorios/atividadesDoProjeto/atividadesDoProjeto.repositorio"
  import { usarEscritorDeDados } from "@/composable/UsarEscritorDeDados/usarEscritorDeDados"
  import { usarLeitorDeDados } from "@/composable/UsarLeitorDeDados/usarLeitorDeDados"
  import {
    ListarUsuarios,
    ParamsUsuario,
  } from "@/repositorios/usuarios/usuarios.modelo"
  import { usarManipuladorObjetos } from "@/composable/UsarManipuladorObjetos/usarManipuladorObjetos"
  import { usarMensagemUsuario } from "@/composable/UsarMensagemUsuario/usarMensagemUsuario"
  import { ListarTiposDeAtividadeFormatado } from "@/repositorios/tiposDeAtividade/tiposDeAtividade.modelo"
  import {
    AtividadeDoProjeto,
    CriarAtividadeDoProjeto,
  } from "@/repositorios/atividadesDoProjeto/atividadesDoProjeto.modelos"
  import { estados } from "@/types/api"
  import { useI18n } from "vue-i18n"

  interface AlertaComReset extends IAlertaMensagem {
    $reset(): void
    legendaBotaoPositivo?: string
    acaoBotaoPositivo?: () => void
    legendaBotaoNeutro?: string
    acaoBotaoNeutro?: () => void
    legendaBotaoNegativo?: string
    acaoBotaoNegativo?: () => void
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'NovoProjeto',
  setup(__props) {

  const { t } = useI18n()

  const home = ref<MenuItem>({
    label: t("projetos"),
    icon: "pi pi-calendar",
    to: "/projetos",
  })

  const breadCrumbItems = ref<MenuItem[]>([
    {
      label: t("novoProjeto"),
      to: "/novo-projeto",
    },
  ])

  const itensTabMenu: MenuItem[] = [
    {
      label: t("membros"),
      icon: "pi pi-angle-right",
      disabled: (): boolean =>
        adicionandoMembros.value || adicionandoTiposDeAtividade.value,
    },
    {
      label: t("atividades"),
      icon: "pi pi-angle-right",
      disabled: (): boolean =>
        adicionandoMembros.value || adicionandoTiposDeAtividade.value,
    },
  ]

  const objetoDialog = reactive<AlertaComReset>({
    icone: "pi pi-exclamation-triangle",
    titulo: t("cancelarCriacaoDoProjeto"),
    tipo: "atencao",
    visivel: false,
    conteudo: t("aoCancelarVocePerderaTodasAsInformacoesNaoSalvas"),
    $reset: function () {
      this.visivel = false
      this.titulo = ""
      this.tipo = "padrao"
      this.conteudo = ""
    },
  })

  const escopoValidacao = "novo_projeto"
  const v$ = useVuelidate({ $scope: escopoValidacao })

  const abaAtiva = ref(0)
  const opcoesDeAbas = {
    abaDeMembros: 0,
    abaDeAtividades: 1,
  }

  const adicionandoMembros = ref<boolean>(false)
  const adicionandoTiposDeAtividade = ref<boolean>(false)

  const nomeProjeto = ref<string>("")
  const codigo = ref<string>("")
  const usuariosResponsaveis = ref<string[]>([])
  const corHexadecimal = ref<string>(COR_PADRAO_PROJETO)
  const membros = ref<MembroDoProjeto[]>([])

  const tiposDeAtividadeAtuaisDoProjeto = ref<
    ListarTiposDeAtividadeFormatado[]
  >([])
  const atividadesDoProjetoAtuais = ref<
    AtividadeDoProjeto[]
  >([])

  const controleDeMembros = computed({
    get() {
      return membros.value
    },
    set(membrosSelecionados: MembroDoProjeto[]) {
      membros.value = listaSemRepeticoes<MembroDoProjeto>(
        membrosSelecionados,
        "idUsuario"
      )
    },
  })

  const controleDeTiposDeAtividade = computed({
    get(): ListarTiposDeAtividadeFormatado[] {
      return tiposDeAtividadeAtuaisDoProjeto.value
    },
    set(atividadesSelecionadas: ListarTiposDeAtividadeFormatado[]) {
      tiposDeAtividadeAtuaisDoProjeto.value =
        listaSemRepeticoes<ListarTiposDeAtividadeFormatado>(
          atividadesSelecionadas,
          "id"
        )
    },
  })

  const estaEmModoAlteracao = computed(
    () => adicionandoMembros.value || adicionandoTiposDeAtividade.value
  )

  const usuariosResponsaveisOpcoes = ref<EntidadeGenerica[]>([])

  const { verificarPermissao } = usarPermissionamento("Projetos")
  const { colher, listaSemRepeticoes } = usarManipuladorObjetos()
  const { escritor } = usarEscritorDeDados()
  const { leitor } = usarLeitorDeDados()
  const { onErro, onSucesso } = usarMensagemUsuario()

  const router = useRouter()
  const route = useRoute()

  const projetoSendoEditado = route.params.id as string

  const projetoRep = new ProjetoRepositorio()
  const usuariosRep = new UsuariosRepositorio()
  const atividadesDoProjetoRep = new AtividadesDoProjetoRepositorio()

  const lerProjetos = leitor<ListarProjetos, ParamsProjeto>(
    projetoRep.listarProjetosFrontend,
    {}
  )
  const lerUsuarios = leitor<ListarUsuarios, ParamsUsuario>(
    usuariosRep.listarUsuarios,
    {}
  )
  const criarProjetoEscritor = escritor<{ id: string }, CriarProjeto>(
    projetoRep.criarProjeto,
    []
  )
  const atualizarProjetoEscritor = escritor<
    { id: string },
    string,
    EditarProjeto
  >(projetoRep.atualizarProjeto, [])

  const projetoSendoCriado = ref<number>(estados.INICIAL)
  const projetoSendoAtualizado = ref<number>(estados.INICIAL)

  const modo = computed(() => (route.params.id ? "atualizar" : "criar"))

  const estagioDeCarregamentoDoProjeto = ref<number>(estados.INICIAL)

  const projetosEstaCarregando = computed(() => {
    return estagioDeCarregamentoDoProjeto.value === estados.PEDENTE
  })

  const submissaoPendente = computed(() => {
    return (
      projetoSendoCriado.value === estados.PEDENTE ||
      projetoSendoAtualizado.value === estados.PEDENTE
    )
  })

  const atividadesDoProjetoValidas = computed(() => {
    const codigos = atividadesDoProjetoAtuais.value.map(
      (atividade) => atividade.codigo.trim()
    )
    const camposPreenchidos = atividadesDoProjetoAtuais.value.every(
      (atividade) => atividade.nome.trim() && atividade.codigo.trim()
    )

    return camposPreenchidos && new Set(codigos).size === codigos.length
  })

  const estaCarregandoDadosDeInicializacao = computed(() => {
    const estaEmModoEdicao = modo.value === "atualizar"
    const estaCarregandoUsuarios = lerUsuarios.resultado.status === "pendente"
    const estaCarregandoProjetos = lerProjetos.resultado.status === "pendente"

    const possuiCarregamentoNaEdicao =
      estaEmModoEdicao && (estaCarregandoUsuarios || estaCarregandoProjetos)
    const possuiCarregamentoNaCriacao =
      !estaEmModoEdicao && estaCarregandoUsuarios

    return possuiCarregamentoNaEdicao || possuiCarregamentoNaCriacao
  })

  const abrirTabelaDeAdicaoDeMembros = (): void => {
    adicionandoMembros.value = true
  }

  const fecharTabelaDeAdicaoDeMembros = (): void => {
    adicionandoMembros.value = false
  }

  const abrirTabelaDeAdicaoDeTiposDeAtividade = (): void => {
    adicionandoTiposDeAtividade.value = true
  }

  const fecharTabelaDeAdicaoDeTiposDeAtividade = (): void => {
    adicionandoTiposDeAtividade.value = false
  }

  const abrirModalDeConfirmacao = (): void => {
    objetoDialog.titulo = t("cancelarCriacaoDoProjeto")
    objetoDialog.conteudo = t("aoCancelarVocePerderaTodasAsInformacoesNaoSalvas")
    objetoDialog.tipo = "atencao"
    objetoDialog.visivel = true
    objetoDialog.legendaBotaoNeutro = t("voltarEditar")
    objetoDialog.acaoBotaoNeutro = (): void => objetoDialog.$reset()
    objetoDialog.legendaBotaoPositivo = t("simCancelar")
    objetoDialog.acaoBotaoPositivo = (): void => cancelarProjeto()
  }

  const cancelarProjeto = (): void => {
    objetoDialog.visivel = false
    router.push("/projetos")
  }

  const mostrarModalParaErroProjetoComCodigoJaExistente = (): void => {
    objetoDialog.titulo = t("naoFoiPossivelSalvar")
    objetoDialog.conteudo = t("codigoInseridoDeveSerUnicoParaTodosOsProfissionaisDoSistema")
    objetoDialog.tipo = "erro"
    objetoDialog.visivel = true
    objetoDialog.legendaBotaoNeutro = t("voltarEditar")
    objetoDialog.acaoBotaoNeutro = (): void => objetoDialog.$reset()
  }

  const mostrarModalParaErroProjetoComNomeJaExistente = (): void => {
    objetoDialog.titulo = t("nomeDoProjetoNaoUnico")
    objetoDialog.conteudo = t("jaExisteUmProjetoComEsseNome")
    objetoDialog.tipo = "atencao"
    objetoDialog.visivel = true
    objetoDialog.legendaBotaoNeutro = t("voltarEditar")
    objetoDialog.acaoBotaoNeutro = () => objetoDialog.$reset()
    objetoDialog.legendaBotaoPositivo = t("salvarMesmoAssim")
    objetoDialog.acaoBotaoPositivo = (): Promise<void> => submeterProjeto()
  }

  const criarProjeto = async (parametrosDoProjeto: CriarProjeto): Promise<void> => {
    projetoSendoCriado.value = estados.PEDENTE

    criarProjetoEscritor.mudarArgumentos([parametrosDoProjeto])
    await criarProjetoEscritor.executar()

    const mensagemDaAPI = t("campoCodigoDeveSerUnico")
    const codigoJaExiste =
      criarProjetoEscritor.resultado.status === "erro" &&
      criarProjetoEscritor.resultado.mensagem === mensagemDaAPI
    const nomeJaExiste =
      criarProjetoEscritor.resultado.status === "erro" &&
      criarProjetoEscritor.resultado.mensagem === ""

    if (criarProjetoEscritor.resultado.status === "sucesso") {
      const { id } = criarProjetoEscritor.resultado.dados
      try {
        await criarNovasAtividadesDoProjeto(id)
        projetoSendoCriado.value = estados.SUCESSO

        onSucesso({
          resumo: t("sucesso"),
          detalhes: t("projetoCriadoComSucesso"),
        })
        router.push(`/projetos`)
      } catch {
        onErro({
          resumo: t("erro"),
          detalhes: t("naoFoiPossivelCriarAtividadesDoProjeto"),
        })
        projetoSendoCriado.value = estados.ERRO
      }
      return
    }

    projetoSendoCriado.value = estados.ERRO
    if (codigoJaExiste) {
      mostrarModalParaErroProjetoComCodigoJaExistente()
    } else if (nomeJaExiste) {
      mostrarModalParaErroProjetoComNomeJaExistente()
    } else {
      onErro({
        resumo: t("erro"),
        detalhes: t("naoFoiPossivelCriarProjeto"),
      })
    }
  }

  const criarNovasAtividadesDoProjeto = async (
    idProjeto: string
  ): Promise<void> => {
    const atividadesNovas = atividadesDoProjetoAtuais.value.filter(
      (atividade) => !atividade.id
    )

    const entradas: CriarAtividadeDoProjeto[] = atividadesNovas.map(
      (atividade) => ({
        idProjeto,
        idTipoDeAtividade: atividade.idTipoDeAtividade,
        nome: atividade.nome,
        codigo: atividade.codigo,
      })
    )

    try {
      for (const entrada of entradas) {
        await atividadesDoProjetoRep.criarAtividadeDoProjeto(entrada)
      }
    } catch {
      projetoSendoCriado.value = estados.ERRO
      projetoSendoAtualizado.value = estados.ERRO
      throw new Error("Não foi possível criar as atividades do projeto")
    }
  }

  const atualizarProjeto = async (parametrosDoProjeto: EditarProjeto): Promise<void> => {
    projetoSendoAtualizado.value = estados.PEDENTE

    atualizarProjetoEscritor.mudarArgumentos([
      projetoSendoEditado,
      parametrosDoProjeto,
    ])
    await atualizarProjetoEscritor.executar()

    if (atualizarProjetoEscritor.resultado.status === "sucesso") {
      const { id } = atualizarProjetoEscritor.resultado.dados
      try {
        await criarNovasAtividadesDoProjeto(id)
        projetoSendoAtualizado.value = estados.SUCESSO

        onSucesso({
          resumo: t("sucesso"),
          detalhes: t("projetoAtualizadoComSucesso"),
        })

        router.push(`/projetos`)
      } catch {
        onErro({
          resumo: t("erro"),
          detalhes: t("naoFoiPossivelAtualizarProjeto"),
        })
        projetoSendoAtualizado.value = estados.ERRO
      }
      return
    }

    onErro({
      resumo: t("erro"),
      detalhes: t("naoFoiPossivelAtualizarProjeto"),
    })
    projetoSendoAtualizado.value = estados.ERRO
  }

  const submeterProjeto = async (): Promise<void> => {
    v$.value.$touch()

    const parametrosDoProjeto: CriarProjeto | EditarProjeto = {
      nomeProjeto: nomeProjeto.value,
      codigo: codigo.value,
      corHexadecimal: corHexadecimal.value,
      idsUsuariosResponsaveis: usuariosResponsaveis.value,
      membros: membros.value,
    }

    if (modo.value === "atualizar") {
      atualizarProjeto(parametrosDoProjeto)
    } else {
      criarProjeto(parametrosDoProjeto)
    }
  }

  const mapearAtividadeDoProjeto = (
    atividade: AtividadeDoProjeto
  ): AtividadeDoProjeto => {
    return {
      ...atividade,
      tipoDeAtividade: {
        id: atividade.idTipoDeAtividade,
        nome: atividade.nome,
        codigo: "",
      },
    }
  }

  const mapearTipoDeAtividade = (atividade: AtividadeDoProjeto) => {
    return {
      id: atividade.idTipoDeAtividade,
      nome: atividade.nome,
      codigo: atividade.tipoDeAtividade?.codigo || "",
      codigoOriginal: atividade.tipoDeAtividade?.codigo || "",
      duracaoPadraoEmMinutos: 0,
    }
  }

  const setarValoresDoProjeto = (
    projeto: ListarProjetosComAtividadesDoProjeto
  ): void => {
    nomeProjeto.value = projeto.nomeProjeto
    corHexadecimal.value = projeto.corHexadecimal ?? COR_PADRAO_PROJETO
    usuariosResponsaveis.value = projeto.usuariosResponsaveis
    controleDeMembros.value = projeto.membros
    atividadesDoProjetoAtuais.value =
      projeto.atividadesDoProjeto.map(mapearAtividadeDoProjeto)
    tiposDeAtividadeAtuaisDoProjeto.value = projeto.atividadesDoProjeto.map(
      mapearTipoDeAtividade
    )
    codigo.value = projeto.codigo
  }

  const carregarDadosModoEditar = async (idProjeto: string): Promise<void> => {
    estagioDeCarregamentoDoProjeto.value = estados.PEDENTE

    lerProjetos.sobrescreverParametros({
      id: `igual.${idProjeto}`,
    })

    await Promise.all([
      lerProjetos.executar(),
      lerUsuarios.porPagina(1000).pagina(0).executar(),
    ])

    if (
      lerProjetos.resultado.status === "sucesso" &&
      lerUsuarios.resultado.status === "sucesso"
    ) {
      setarValoresDoProjeto(
        lerProjetos.resultado.dados[0] as ListarProjetosComAtividadesDoProjeto
      )
      await nextTick()
      usuariosResponsaveisOpcoes.value = colher<
        ListarUsuarios,
        { id: string; nome: string }
      >(lerUsuarios.resultado.dados, ["id", "nome"], ["id", "nome"])

      estagioDeCarregamentoDoProjeto.value = estados.SUCESSO
    }
    if (
      lerProjetos.resultado.status === "erro" ||
      lerUsuarios.resultado.status === "erro"
    ) {
      onErro(
        {
          resumo: t("erroInesperado"),
          detalhes: t("ocorreuUmErroAoTentarCarregarProjetoParaEdicao"),
        },
        () => {
          router.push("/projetos")
        }
      )

      estagioDeCarregamentoDoProjeto.value = estados.ERRO
    }
  }

  const carregarDadosModoCriar = async (): Promise<void> => {
    estagioDeCarregamentoDoProjeto.value = estados.PEDENTE

    await lerUsuarios.porPagina(1000).pagina(0).executar()

    if (lerUsuarios.resultado.status === "sucesso") {
      usuariosResponsaveisOpcoes.value = colher<
        ListarUsuarios,
        { id: string; nome: string }
      >(lerUsuarios.resultado.dados, ["id", "nome"])
      estagioDeCarregamentoDoProjeto.value = estados.SUCESSO
    }

    if (lerUsuarios.resultado.status === "erro") {
      estagioDeCarregamentoDoProjeto.value = estados.ERRO
      onErro(
        {
          resumo: t("erroInesperado"),
          detalhes: t("ocorreuUmErroAoTentarCarregarInformacoesParCriarUmNovoProjeto")
        },
        () => {
          router.push("/projetos")
        }
      )
    }
  }

  const concatenarCodigoDoProjetoComCodigoDeCadaAtividadeDoProjeto =
    (codigoDoProjeto, codigoAntigo): void => {
      atividadesDoProjetoAtuais.value =
        atividadesDoProjetoAtuais.value.map((atividadeDoProjeto) => {
          if (atividadeDoProjeto.id || !atividadeDoProjeto.tipoDeAtividade) {
            return atividadeDoProjeto
          }

          const tamanhoCodigoTipoDeAtividade =
            atividadeDoProjeto.tipoDeAtividade.codigo.length
          const tamanhoCodigoAtividadeDoProjeto =
            atividadeDoProjeto.codigo.length
          const tamanhoDoCodigoDoProjetoASerAlterado = codigoAntigo.length
          const codigoTipoDeAtividade =
            atividadeDoProjeto.tipoDeAtividade.codigo

          const comecaComCodigoTipoDeAtividade =
            atividadeDoProjeto.codigo.startsWith(codigoTipoDeAtividade)
          const codigoDoProjetoIgualAoCodigoAntigo =
            atividadeDoProjeto.codigo.substring(
              tamanhoCodigoTipoDeAtividade,
              tamanhoCodigoTipoDeAtividade +
                tamanhoDoCodigoDoProjetoASerAlterado
            ) === codigoAntigo

          if (
            codigoDoProjetoIgualAoCodigoAntigo &&
            comecaComCodigoTipoDeAtividade
          ) {
            const hash = atividadeDoProjeto.codigo.substring(
              tamanhoCodigoTipoDeAtividade +
                tamanhoDoCodigoDoProjetoASerAlterado,
              tamanhoCodigoAtividadeDoProjeto
            )

            return {
              ...atividadeDoProjeto,
              codigo: `${codigoTipoDeAtividade}${codigoDoProjeto}${hash}`,
            }
          }

          return atividadeDoProjeto
        })
    }

  const gerarCodigoUnico = (): number => {
    const tempoUnico = new Date().getTime()
    const numeroAleatorio = Math.floor(Math.random() * 1000)
    return tempoUnico + numeroAleatorio
  }

  const montarEstruturaDasAtividadesAdicionadasQueSeraoMostradasNaTabela = (
    tiposDeAtividade: ListarTiposDeAtividadeFormatado[]
  ): AtividadeDoProjeto[] => {
    return tiposDeAtividade.map((tipoDeAtividade) => {
      return {
        idTipoDeAtividade: tipoDeAtividade.id,
        nome: tipoDeAtividade.nome,
        codigo: `${tipoDeAtividade.codigo}${codigo.value}${gerarCodigoUnico()}`,
        tipoDeAtividade: {
          id: tipoDeAtividade.id,
          nome: tipoDeAtividade.nome,
          codigo: tipoDeAtividade.codigo,
        },
      }
    })
  }

  const naoExisteAtividadeDoProjeto = (atividadesDoProjeto: AtividadeDoProjeto[], atividadesAdicionadas: AtividadeDoProjeto[]): boolean => {
    return !atividadesDoProjeto.some((atividadeExistente) => atividadesAdicionadas.some(
      (novaAtividade) => novaAtividade.idTipoDeAtividade === atividadeExistente.idTipoDeAtividade)
    )
  }

  const adicionarAtividadesDoProjetoNaEstrutura = (tiposDeAtividadeAdicionados: ListarTiposDeAtividadeFormatado[]): void => {
    if (tiposDeAtividadeAdicionados.length) {
      const atividadesAdicionadasMapeadas = montarEstruturaDasAtividadesAdicionadasQueSeraoMostradasNaTabela(
      tiposDeAtividadeAdicionados
    )

      if (naoExisteAtividadeDoProjeto(atividadesDoProjetoAtuais.value, atividadesAdicionadasMapeadas)) {
        atividadesDoProjetoAtuais.value = atividadesDoProjetoAtuais.value.concat(atividadesAdicionadasMapeadas)
      }
    }
  }

  const removerAtividadesDoProjetoNaEstrutura = (
    tiposDeAtividadeRemovidos: ListarTiposDeAtividadeFormatado[]
  ): void => {
    if (tiposDeAtividadeRemovidos.length) {
      atividadesDoProjetoAtuais.value =
        atividadesDoProjetoAtuais.value.filter(
          (atividadeDoProjeto) => {
            if (atividadeDoProjeto.id) {
              return true
            }

            return !tiposDeAtividadeRemovidos.some(
              (tipoDeAtividadeRemovido) => {
                return (
                  atividadeDoProjeto.idTipoDeAtividade ===
                  tipoDeAtividadeRemovido.id
                )
              }
            )
          }
        )
    }
  }

  const montarEstruturasDasAtividadesDoProjeto = (
    tiposDeAtividadeAdicionados: ListarTiposDeAtividadeFormatado[],
    tiposDeAtividadeRemovidos: ListarTiposDeAtividadeFormatado[]
  ): void => {
    adicionarAtividadesDoProjetoNaEstrutura(tiposDeAtividadeAdicionados)
    removerAtividadesDoProjetoNaEstrutura(tiposDeAtividadeRemovidos)
  }

  watch(codigo, (codigoDoProjeto, codigoAntigo) => {
    if (projetosEstaCarregando.value) {
      return
    }
    concatenarCodigoDoProjetoComCodigoDeCadaAtividadeDoProjeto(
      codigoDoProjeto,
      codigoAntigo
    )
  })

  onBeforeMount(() => {
    estagioDeCarregamentoDoProjeto.value = estados.PEDENTE

    const id = route.params.id as string

    if (modo.value === "atualizar") {
      carregarDadosModoEditar(id)
    } else {
      carregarDadosModoCriar()
    }
  })

return (_ctx: any,_cache: any) => {
  const _component_TabMenu = _resolveComponent("TabMenu")!
  const _component_Skeleton = _resolveComponent("Skeleton")!

  return (_openBlock(), _createBlock(_unref(LPadrao), {
    class: "NovoProjeto",
    "data-testid": "NovoProjeto"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(TNovoProjeto), null, _createSlots({
        titulo: _withCtx(() => [
          _createVNode(_unref(OTrilhaDeNavegacao), {
            "inicio-da-trilha": home.value,
            "itens-da-trilha": breadCrumbItems.value
          }, null, 8, ["inicio-da-trilha", "itens-da-trilha"])
        ]),
        campos: _withCtx(() => [
          _createVNode(_unref(ODadosProjeto), {
            codigo: codigo.value,
            "onUpdate:codigo": _cache[0] || (_cache[0] = ($event: any) => ((codigo).value = $event)),
            "cor-hexadecimal": corHexadecimal.value,
            "onUpdate:cor-hexadecimal": _cache[1] || (_cache[1] = ($event: any) => ((corHexadecimal).value = $event)),
            membros: membros.value,
            "onUpdate:membros": _cache[2] || (_cache[2] = ($event: any) => ((membros).value = $event)),
            "nome-projeto": nomeProjeto.value,
            "onUpdate:nome-projeto": _cache[3] || (_cache[3] = ($event: any) => ((nomeProjeto).value = $event)),
            "tipos-de-atividade": tiposDeAtividadeAtuaisDoProjeto.value,
            "onUpdate:tipos-de-atividade": _cache[4] || (_cache[4] = ($event: any) => ((tiposDeAtividadeAtuaisDoProjeto).value = $event)),
            "usuarios-responsaveis": usuariosResponsaveis.value,
            "onUpdate:usuarios-responsaveis": _cache[5] || (_cache[5] = ($event: any) => ((usuariosResponsaveis).value = $event)),
            "escopo-validacao": escopoValidacao,
            "usuarios-responsaveis-opcoes": usuariosResponsaveisOpcoes.value
          }, null, 8, ["codigo", "cor-hexadecimal", "membros", "nome-projeto", "tipos-de-atividade", "usuarios-responsaveis", "usuarios-responsaveis-opcoes"])
        ]),
        tabmenu: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_TabMenu, {
              activeIndex: abaAtiva.value,
              "onUpdate:activeIndex": _cache[6] || (_cache[6] = ($event: any) => ((abaAtiva).value = $event)),
              class: "NovoProjeto__TabMenu",
              "data-testid": "NovoProjeto__TabMenu",
              disabled: _unref(estaEmModoAlteracao),
              model: itensTabMenu
            }, null, 8, ["activeIndex", "disabled"]),
            (abaAtiva.value === opcoesDeAbas.abaDeMembros && !_unref(estaEmModoAlteracao))
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(_unref(PButton), {
                    onClick: abrirTabelaDeAdicaoDeMembros,
                    class: "ONovoMembro__Adicionar p-button-warning",
                    "data-testid": "ONovoMembro__Adicionar",
                    label: _unref(t)('adicionarMembros')
                  }, null, 8, ["label"])
                ]))
              : _createCommentVNode("", true),
            (abaAtiva.value === opcoesDeAbas.abaDeAtividades && !_unref(estaEmModoAlteracao))
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createVNode(_unref(PButton), {
                    onClick: abrirTabelaDeAdicaoDeTiposDeAtividade,
                    class: "NovoProjeto__AdicionarTiposDeAtividades p-button-warning",
                    "data-testid": "NovoProjeto__AdicionarTiposDeAtividades",
                    label: _unref(t)('adicionarTiposDeAtividades')
                  }, null, 8, ["label"])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        centro: _withCtx(() => [
          (_unref(estaCarregandoDadosDeInicializacao))
            ? (_openBlock(), _createBlock(_component_Skeleton, {
                key: 0,
                "data-testid": "NovoProjeto__CarregamentoDeAbas",
                height: "220px",
                width: "100%"
              }))
            : _createCommentVNode("", true),
          _withDirectives(_createVNode(_unref(ONovoMembro), {
            "membros-selecionados": _unref(controleDeMembros),
            "onUpdate:membros-selecionados": _cache[7] || (_cache[7] = ($event: any) => (_isRef(controleDeMembros) ? (controleDeMembros).value = $event : null)),
            "abrir-tabela-de-adicao-de-membros": abrirTabelaDeAdicaoDeMembros,
            "adicionando-membros": adicionandoMembros.value,
            "fechar-tabela-de-adicao-de-membros": fecharTabelaDeAdicaoDeMembros
          }, null, 8, ["membros-selecionados", "adicionando-membros"]), [
            [_vShow, abaAtiva.value === opcoesDeAbas.abaDeMembros && !_unref(estaCarregandoDadosDeInicializacao)]
          ]),
          _withDirectives(_createVNode(_unref(ONovaAtividade), {
            "tipos-de-atividade-selecionados": _unref(controleDeTiposDeAtividade),
            "onUpdate:tipos-de-atividade-selecionados": _cache[8] || (_cache[8] = ($event: any) => (_isRef(controleDeTiposDeAtividade) ? (controleDeTiposDeAtividade).value = $event : null)),
            "abrir-tabela-de-adicao-de-tipos-de-atividade": 
            abrirTabelaDeAdicaoDeTiposDeAtividade
          ,
            "adicionando-tipos-de-atividade": adicionandoTiposDeAtividade.value,
            "atividades-do-projeto": 
            atividadesDoProjetoAtuais.value
          ,
            "fechar-tabela-de-adicao-de-tipos-de-atividade": 
            fecharTabelaDeAdicaoDeTiposDeAtividade
          ,
            "montar-estruturas-das-atividades-do-projeto": 
            montarEstruturasDasAtividadesDoProjeto
          
          }, null, 8, ["tipos-de-atividade-selecionados", "abrir-tabela-de-adicao-de-tipos-de-atividade", "adicionando-tipos-de-atividade", "atividades-do-projeto", "fechar-tabela-de-adicao-de-tipos-de-atividade", "montar-estruturas-das-atividades-do-projeto"]), [
            [_vShow, abaAtiva.value === opcoesDeAbas.abaDeAtividades && !_unref(estaCarregandoDadosDeInicializacao)]
          ])
        ]),
        modais: _withCtx(() => [
          _createVNode(_unref(MModalDeAlerta), {
            modelValue: objetoDialog.visivel,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((objetoDialog.visivel) = $event)),
            cabecalho: objetoDialog.titulo,
            tipo: objetoDialog.tipo
          }, {
            conteudo: _withCtx(() => [
              _createTextVNode(_toDisplayString(objetoDialog.conteudo), 1)
            ]),
            acoes: _withCtx(() => [
              (objetoDialog.acaoBotaoNeutro)
                ? (_openBlock(), _createBlock(_unref(PButton), {
                    key: 0,
                    onClick: objetoDialog.acaoBotaoNeutro,
                    class: "NovoProjeto__Botao p-button-text",
                    disabled: _unref(submissaoPendente),
                    label: objetoDialog.legendaBotaoNeutro,
                    loading: _unref(submissaoPendente)
                  }, null, 8, ["onClick", "disabled", "label", "loading"]))
                : _createCommentVNode("", true),
              (objetoDialog.acaoBotaoPositivo)
                ? (_openBlock(), _createBlock(_unref(PButton), {
                    key: 1,
                    onClick: objetoDialog.acaoBotaoPositivo,
                    class: "NovoProjeto__Botao p-button-danger",
                    disabled: _unref(submissaoPendente),
                    label: objetoDialog.legendaBotaoPositivo
                  }, null, 8, ["onClick", "disabled", "label"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["modelValue", "cabecalho", "tipo"])
        ]),
        _: 2
      }, [
        (!_unref(estaEmModoAlteracao))
          ? {
              name: "acoes",
              fn: _withCtx(() => [
                (_unref(verificarPermissao)('criar'))
                  ? (_openBlock(), _createBlock(_unref(PButton), {
                      key: 0,
                      onClick: submeterProjeto,
                      class: "NovoProjeto__Botao NovoProjeto__Salvar p-button-success",
                      disabled: _unref(v$).$invalid || _unref(submissaoPendente) || !_unref(atividadesDoProjetoValidas),
                      label: _unref(t)('salvar'),
                      loading: _unref(submissaoPendente)
                    }, null, 8, ["disabled", "label", "loading"]))
                  : _createCommentVNode("", true),
                _createVNode(_unref(PButton), {
                  onClick: abrirModalDeConfirmacao,
                  class: "NovoProjeto__Botao p-button-danger",
                  disabled: _unref(submissaoPendente),
                  label: _unref(t)('cancelar')
                }, null, 8, ["disabled", "label"])
              ]),
              key: "0"
            }
          : undefined
      ]), 1024)
    ]),
    _: 1
  }))
}
}

})